import { useContext, useState, useEffect } from "react";
import { TotalEntradaUtils } from "../../utils/TotalEntradaUtils";
import { ValidarEntrada } from "../../utils/ValidarEntrada";
import { ValidarMembresia } from "../../utils/ValidarMembresia";
import { ValidarStock } from "../../utils/ValidarStock";
import SiteMapViewer from "./SiteMapViewer";

const OfComprarEntradas = ({
  setStep,
  step,
  entradas,
  onClick,
  comission,
  form,
  evento,
  fechas,
  label,
  image,
  me,
  setmembresia,
  asientosSeleccionados,
  setAsientosSeleccionados,
}) => {
  const [siteMap, setSiteMap] = useState(null);
  const [entradaConSector, setEntradaConSector] = useState(null);

  // Función para generar un sitemap virtual basado en entradas con sector
  const generarSiteMapVirtual = (entradas) => {
    console.log("=== Generando sitemap virtual (MOBILE) ===");

    const sectores = [];
    const asientos = [];
    let asientoIdCounter = 1;

    const colores = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E2'];
    let colorIndex = 0;
    let yOffset = 50;

    entradas.forEach((entrada, entradaIdx) => {
      let nombreSector = '';
      if (typeof entrada.sector === 'string' && entrada.sector.trim() !== "") {
        nombreSector = entrada.sector.trim();
      } else if (entrada.sector && entrada.sector[0]) {
        nombreSector = entrada.sector[0].trim();
      }

      if (nombreSector && entrada.stock > 0) {
        const sectorId = entradaIdx + 1;
        const color = colores[colorIndex % colores.length];
        colorIndex++;

        sectores.push({
          id: sectorId,
          nombre: nombreSector,
          color: color,
          capacidad: entrada.stock,
          visible: true
        });

        // Parsear cuadrante_config si existe
        let cuadranteConfig = null;
        if (entrada.cuadrante_config) {
          try {
            cuadranteConfig = typeof entrada.cuadrante_config === 'string'
              ? JSON.parse(entrada.cuadrante_config)
              : entrada.cuadrante_config;
            console.log(`✅ Cuadrante config cargado para ${nombreSector}:`, cuadranteConfig);
          } catch (e) {
            console.error(`Error al parsear cuadrante_config para ${nombreSector}:`, e);
          }
        }

        // Si hay cuadrante_config, usar esa configuración
        if (cuadranteConfig && cuadranteConfig.filas && cuadranteConfig.filas.length > 0) {
          console.log(`📐 Usando cuadrante_config para ${nombreSector}`);

          let filaYOffset = yOffset;

          cuadranteConfig.filas.forEach((filaConfig) => {
            const numeroFila = filaConfig.numero;
            const asientoInicio = filaConfig.inicio;
            const asientoFin = filaConfig.fin;
            const cantidadAsientos = asientoFin - asientoInicio + 1;

            console.log(`  Fila ${numeroFila}: asientos ${asientoInicio} a ${asientoFin} (${cantidadAsientos} asientos)`);

            // Crear asientos para esta fila
            for (let numAsiento = asientoInicio; numAsiento <= asientoFin; numAsiento++) {
              const columna = numAsiento - asientoInicio;

              asientos.push({
                id: asientoIdCounter++,
                numero: String(numAsiento),
                numeroFila: numeroFila,
                fila: `Fila ${numeroFila}`,
                x: 50 + (columna * 60),
                y: filaYOffset,
                width: 50,
                height: 40,
                sector_id: sectorId,
                sector: nombreSector,
                nombre: `${nombreSector} - Fila ${numeroFila} - Asiento ${numAsiento}`,
                estado: 'disponible'
              });
            }

            filaYOffset += 50;
          });

          yOffset = filaYOffset + 100;
        }
        // Si NO hay cuadrante_config, usar distribución automática
        else {
          console.log(`⚠️ No hay cuadrante_config para ${nombreSector}, usando distribución automática`);

          const asientosPorFila = 20;
          const filas = Math.ceil(entrada.stock / asientosPorFila);

          for (let i = 0; i < entrada.stock; i++) {
            const fila = Math.floor(i / asientosPorFila);
            const columna = i % asientosPorFila;
            const numeroAsiento = i + 1;
            const numeroFila = fila + 1;

            asientos.push({
              id: asientoIdCounter++,
              numero: String(numeroAsiento),
              numeroFila: numeroFila,
              fila: `Fila ${numeroFila}`,
              x: 50 + (columna * 60),
              y: yOffset + (fila * 50),
              width: 50,
              height: 40,
              sector_id: sectorId,
              sector: nombreSector,
              nombre: `${nombreSector} - Fila ${numeroFila} - Asiento ${numAsiento}`,
              estado: 'disponible'
            });
          }

          yOffset += (filas * 50) + 100;
        }
      }
    });

    if (sectores.length === 0) return null;

    return {
      version: "2.0",
      nombre: "Mapa generado automáticamente",
      asientos,
      sectores,
      escenario: null,
      elementosEspeciales: [],
      workspaceGridColumns: 50,
      workspaceGridRows: Math.ceil(yOffset / 28) + 5,
      imagenFondo: null,
      opacidadFondo: 0,
      isVirtual: true
    };
  };

  // Cargar site_maps cuando se carga el evento
  useEffect(() => {
    console.log("=== EVENTO RECIBIDO EN COMPRAR ENTRADAS (MOBILE) ===");
    console.log("Evento completo:", evento);
    console.log("Reportes del evento:", evento?.reportes);

    if (evento && evento.site_maps) {
      console.log("site_maps encontrado:", evento.site_maps);

      const siteMapData = evento.site_maps;
      console.log("Datos de site_map:", siteMapData);

      // Parsear site_map si viene como string
      let parsedSiteMap = siteMapData.site_map;
      console.log("Tipo de site_map:", typeof parsedSiteMap);

      if (typeof parsedSiteMap === 'string') {
        try {
          parsedSiteMap = JSON.parse(parsedSiteMap);
          setSiteMap(parsedSiteMap);
          console.log("Site map parseado y guardado:", parsedSiteMap);
        } catch (e) {
          console.error("Error al parsear site_map:", e);
        }
      } else {
        setSiteMap(parsedSiteMap);
        console.log("Site map guardado (ya es objeto):", parsedSiteMap);
      }
    } else {
      console.log("No se encontró site_maps en el evento - verificando entradas con sector");

      if (entradas && entradas.length > 0) {
        const hayEntradasConSector = entradas.some(entrada => {
          const tieneSector = (typeof entrada.sector === 'string' && entrada.sector.trim() !== "") ||
            (entrada.sector && entrada.sector[0] && entrada.sector[0].trim() !== "");
          const tieneStock = entrada.stock > 0;
          return tieneSector && tieneStock;
        });

        if (hayEntradasConSector) {
          console.log("✨ Generando sitemap virtual basado en entradas con sector");
          const virtualSiteMap = generarSiteMapVirtual(entradas);
          if (virtualSiteMap) {
            setSiteMap(virtualSiteMap);
          }
        }
      }
    }
  }, [evento, entradas]);

  // Detectar si hay entradas con sector O si hay un sitemap con asientos
  useEffect(() => {
    console.log("Verificando entradas con sector:", entradas);
    console.log("Site map actual:", siteMap);

    // Verificar diferentes formatos posibles del campo sector
    const hayEntradasConSector = entradas.some(entrada => {
      console.log("Verificando entrada:", entrada);
      console.log("Campo sector:", entrada.sector);

      // Puede venir como string directo o como objeto/array
      if (typeof entrada.sector === 'string' && entrada.sector.trim() !== "") {
        return true;
      }
      // Podría venir como objeto con propiedad [0]
      if (entrada.sector && entrada.sector[0] && entrada.sector[0].trim() !== "") {
        return true;
      }
      return false;
    });

    // NUEVO: También verificar si existe un sitemap con asientos
    const haySiteMapConAsientos = siteMap && siteMap.asientos && siteMap.asientos.length > 0;

    console.log("¿Existen entradas con sector?:", hayEntradasConSector);
    console.log("¿Hay sitemap con asientos?:", haySiteMapConAsientos);

    // Mostrar mapa si hay entradas con sector O si hay sitemap con asientos
    const deberiaUsarMapa = hayEntradasConSector || haySiteMapConAsientos;
    console.log("¿Debería usar mapa?:", deberiaUsarMapa);

    setEntradaConSector(deberiaUsarMapa);
  }, [entradas, siteMap]);

  // Manejar selección de asiento
  const handleAsientoSelect = (asiento) => {
    console.log("=== handleAsientoSelect ejecutado (MOBILE) ===");
    console.log("Asiento recibido:", asiento);
    console.log("Asientos seleccionados actuales:", asientosSeleccionados);

    setAsientosSeleccionados(prev => {
      const index = prev.findIndex(a => a.id === asiento.id);
      console.log("Índice encontrado:", index);

      if (index > -1) {
        // Deseleccionar
        const nuevaSeleccion = prev.filter(a => a.id !== asiento.id);
        console.log("Deseleccionando. Nueva selección:", nuevaSeleccion);
        return nuevaSeleccion;
      } else {
        // Seleccionar - IMPORTANTE: incluir sector_id
        const nuevaSeleccion = [...prev, { ...asiento }];
        console.log("Seleccionando. Nueva selección:", nuevaSeleccion);
        return nuevaSeleccion;
      }
    });
  };

  // Sincronizar cantidad de entradas con asientos seleccionados
  useEffect(() => {
    console.log("Sincronizando asientos seleccionados:", asientosSeleccionados);
    console.log("Sitemap disponible:", siteMap);

    if (!siteMap || !siteMap.sectores) {
      console.log("No hay sitemap o sectores para sincronizar");
      return;
    }

    // Iterar sobre TODAS las entradas y actualizar sus cantidades
    entradas.forEach((entrada, index) => {
      console.log(`\n=== Procesando entrada ${index}: ${entrada.nombre} (MOBILE) ===`);
      console.log("Entrada completa:", entrada);
      console.log("Campo sector:", entrada.sector);

      let sectorId = null;
      let nombreSectorEntrada = '';

      // Extraer el nombre del sector de la entrada
      if (typeof entrada.sector === 'string' && entrada.sector.trim() !== "") {
        nombreSectorEntrada = entrada.sector.trim();
        console.log(`Sector de entrada (string): "${nombreSectorEntrada}"`);
      } else if (entrada.sector && entrada.sector[0] && entrada.sector[0].trim() !== "") {
        nombreSectorEntrada = entrada.sector[0].trim();
        console.log(`Sector de entrada (array[0]): "${nombreSectorEntrada}"`);
      } else if (Array.isArray(entrada.sector) && entrada.sector.length > 0) {
        nombreSectorEntrada = entrada.sector[0] ? String(entrada.sector[0]).trim() : '';
        console.log(`Sector de entrada (array convertido): "${nombreSectorEntrada}"`);
      }

      // Si la entrada tiene un sector definido, buscar en el sitemap
      if (nombreSectorEntrada !== '') {
        console.log(`Buscando sector "${nombreSectorEntrada}" en sitemap...`);
        console.log("Sectores disponibles en sitemap:", siteMap.sectores.map(s => `${s.nombre || s.name} (ID: ${s.id})`));

        const sectorEnMapa = siteMap.sectores.find(sector => {
          const nombreSectorMapa = sector.nombre || sector.name || '';

          // Comparar nombres (case insensitive y sin espacios extras)
          const match = nombreSectorMapa.trim().toLowerCase() === nombreSectorEntrada.toLowerCase();

          if (match) {
            console.log(`✅ MATCH ENCONTRADO: Sector sitemap "${nombreSectorMapa}" (ID: ${sector.id}) = Entrada sector "${nombreSectorEntrada}"`);
          }

          return match;
        });

        if (sectorEnMapa) {
          sectorId = sectorEnMapa.id;
          console.log(`✅ Sector vinculado: ID ${sectorId}`);
        } else {
          console.log(`❌ No se encontró match para el sector "${nombreSectorEntrada}"`);
        }
      } else {
        // Si no tiene sector, intentar match por nombre de entrada
        console.log("Entrada sin sector definido, buscando por nombre de entrada...");
        const sectorEnMapa = siteMap.sectores.find(sector => {
          const nombreSectorMapa = sector.nombre || sector.name || '';
          const nombreEntrada = entrada.nombre || '';

          const match = nombreSectorMapa.trim().toLowerCase() === nombreEntrada.trim().toLowerCase();

          if (match) {
            console.log(`✅ Match por nombre de entrada: Sector "${nombreSectorMapa}" (ID: ${sector.id}) = Entrada "${nombreEntrada}"`);
          }

          return match;
        });

        if (sectorEnMapa) {
          sectorId = sectorEnMapa.id;
          console.log(`Entrada ${entrada.id} (${entrada.nombre}) vinculada con sector ${sectorId} por nombre`);
        } else {
          console.log(`⚠️ No se encontró sector en el mapa para la entrada: ${entrada.nombre}`);
        }
      }

      // Si encontramos un sector (ya sea explícito o por nombre), contar asientos
      if (sectorId !== null) {
        // Contar asientos seleccionados de este sector específico
        const asientosDelSector = asientosSeleccionados.filter(a => {
          const match = a.sector_id == sectorId;
          if (match) {
            console.log(`  ✅ Asiento ${a.id} pertenece al sector ${sectorId} (asiento.sector_id=${a.sector_id})`);
          }
          return match;
        });
        const cantidadAsientos = asientosDelSector.length;

        console.log(`Entrada ${entrada.id} (${entrada.nombre}): ${cantidadAsientos} asientos seleccionados del sector ${sectorId}`);
        console.log(`  Asientos de este sector:`, asientosDelSector.map(a => `${a.id} (fila ${a.fila}, num ${a.numero})`));

        // Actualizar solo si cambió la cantidad
        if (entrada.quantity !== cantidadAsientos) {
          const event = { target: { name: 'update-quantity-from-sitemap' } };
          const value = {
            index: index,
            cantidad: cantidadAsientos,
            precio: entrada.precio
          };

          console.log(`🔄 Actualizando entrada ${entrada.id} a cantidad: ${cantidadAsientos}`);
          onClick(event, value);
        }
      }
    });
  }, [asientosSeleccionados, siteMap]);

  return (
    <div
      className="offcanvas offcanvas-top min-vh-100"
      tabindex="-1"
      id="offcanvasTop-comprar-entradas"
      aria-labelledby="offcanvasTopLabel"
    >
      <div className="offcanvas-header py-2">
        <h5
          className="offcanvas-title Grifter"
          id="offcanvasTopLabel-comprar-entradas"
          style={{ fontSize: "12px" }}
        ></h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div className="offcanvas-body">
        <div className="row">
          <div className="col-12 mb-3">
            {(() => {
              console.log("Estado de renderizado - siteMap:", siteMap);
              console.log("Estado de renderizado - entradaConSector:", entradaConSector);
              console.log("¿Debería mostrar mapa?", siteMap && entradaConSector);
              return null;
            })()}
            {siteMap && entradaConSector ? (
              <div className="p-2">
                {siteMap.isVirtual ? (
                  // Selector de asientos HTML simple para mapas virtuales (Mobile)
                  <div>
                    <h6 className="text-success mb-3">
                      <i className="bi bi-ticket-perforated me-2"></i>
                      Selección de Asientos
                    </h6>

                    {/* Mostrar imagen de guía si existe */}
                    {evento.maps_sitio && (
                      <div className="mb-3 border rounded overflow-hidden shadow-sm">
                        <div className="bg-naranja text-white p-2 d-flex justify-content-between align-items-center">
                          <small className="fw-bold">
                            <i className="bi bi-map me-1"></i>
                            Mapa de Referencia
                          </small>
                          <small className="text-white-50">
                            <i className="bi bi-zoom-in me-1"></i>
                            Toca para ampliar
                          </small>
                        </div>
                        <img
                          src={evento.maps_sitio}
                          alt="Mapa de guía de asientos"
                          className="w-100"
                          style={{
                            maxHeight: '300px',
                            objectFit: 'contain',
                            backgroundColor: '#f8f9fa',
                            cursor: 'pointer'
                          }}
                          onClick={() => {
                            // Crear modal de zoom
                            const modal = document.createElement('div');
                            modal.style.cssText = `
                              position: fixed;
                              top: 0;
                              left: 0;
                              width: 100%;
                              height: 100%;
                              background: rgba(0,0,0,0.9);
                              z-index: 9999;
                              display: flex;
                              align-items: center;
                              justify-content: center;
                              padding: 20px;
                              cursor: zoom-out;
                            `;

                            const img = document.createElement('img');
                            img.src = evento.maps_sitio;
                            img.style.cssText = `
                              max-width: 100%;
                              max-height: 100%;
                              object-fit: contain;
                              box-shadow: 0 0 30px rgba(255,255,255,0.2);
                            `;

                            const closeBtn = document.createElement('button');
                            closeBtn.innerHTML = '<i class="bi bi-x-lg"></i>';
                            closeBtn.style.cssText = `
                              position: absolute;
                              top: 20px;
                              right: 20px;
                              background: white;
                              border: none;
                              width: 40px;
                              height: 40px;
                              border-radius: 50%;
                              font-size: 20px;
                              cursor: pointer;
                              box-shadow: 0 2px 10px rgba(0,0,0,0.3);
                              display: flex;
                              align-items: center;
                              justify-content: center;
                            `;

                            modal.appendChild(img);
                            modal.appendChild(closeBtn);
                            document.body.appendChild(modal);

                            const cerrarModal = () => {
                              modal.remove();
                            };

                            modal.addEventListener('click', cerrarModal);
                            closeBtn.addEventListener('click', cerrarModal);

                            // Evitar que el click en la imagen cierre el modal
                            img.addEventListener('click', (e) => e.stopPropagation());
                          }}
                        />
                      </div>
                    )}

                    {/* Lista de sectores con botones de asientos */}
                    {siteMap.sectores.map((sector, sectorIdx) => {
                      // Obtener asientos de este sector
                      const asientosSector = siteMap.asientos.filter(a => a.sector_id === sector.id);

                      // Obtener asientos vendidos de este sector para la fecha seleccionada
                      const asientosVendidos = new Set();
                      const fechaSeleccionada = `${form.fecha} HORA: ${form.hora}`;

                      console.log(`Buscando asientos vendidos para fecha: "${fechaSeleccionada}"`);

                      evento.reportes?.forEach(reporte => {
                        // Verificar que el reporte sea de la misma fecha seleccionada
                        if (reporte.fecha !== fechaSeleccionada) {
                          return; // Saltar este reporte si no es la fecha seleccionada
                        }

                        console.log(`✅ Reporte coincide con fecha seleccionada:`, reporte);

                        // Iterar sobre reporte_codigo que contiene los asientos vendidos
                        if (reporte.reporte_codigo && Array.isArray(reporte.reporte_codigo)) {
                          reporte.reporte_codigo.forEach(codigo => {
                            if (codigo.sector_numero && codigo.status === 'ACTIVO') {
                              const sectorNumeroStr = String(codigo.sector_numero).trim();
                              console.log(`🔍 Buscando match para: "${sectorNumeroStr}"`);

                              asientosSector.forEach(asiento => {
                                // Método 1: Comparación exacta con el campo nombre del asiento
                                // Formato: "Sector A - Fila 2 - Asiento 15"
                                if (asiento.nombre && sectorNumeroStr === asiento.nombre) {
                                  asientosVendidos.add(asiento.id);
                                  console.log(`✅ Asiento vendido (exacto): ${asiento.nombre}`);
                                  return;
                                }

                                // Método 2: Buscar patrón completo "Sector X - Fila Y - Asiento Z"
                                const matchCompleto = sectorNumeroStr.match(/(.+?)\s*-\s*Fila\s+(\w+)\s*-\s*Asiento\s+(\d+)/i);
                                if (matchCompleto) {
                                  const sectorEnReporte = matchCompleto[1].trim();
                                  const filaEnReporte = matchCompleto[2].trim();
                                  const numeroEnReporte = matchCompleto[3];

                                  // Comparar sector, fila y número de asiento
                                  const sectorMatch = sectorEnReporte.toLowerCase() === sector.nombre.toLowerCase();
                                  const filaMatch = String(filaEnReporte) === String(asiento.numeroFila);
                                  const asientoMatch = numeroEnReporte === asiento.numero;

                                  if (sectorMatch && filaMatch && asientoMatch) {
                                    asientosVendidos.add(asiento.id);
                                    console.log(`✅ Asiento vendido (completo): ${sectorEnReporte} - Fila ${filaEnReporte} - Asiento ${numeroEnReporte}`);
                                    return;
                                  }
                                }

                                // Método 3: Buscar patrón sin fila "Sector X - Asiento Y" (compatibilidad retroactiva)
                                const matchSinFila = sectorNumeroStr.match(/(.+?)\s*-\s*Asiento\s+(\d+)/i);
                                if (matchSinFila) {
                                  const sectorEnReporte = matchSinFila[1].trim();
                                  const numeroEnReporte = matchSinFila[2];

                                  if (sectorEnReporte.toLowerCase() === sector.nombre.toLowerCase() &&
                                      numeroEnReporte === asiento.numero) {
                                    asientosVendidos.add(asiento.id);
                                    console.log(`✅ Asiento vendido (sin fila): ${sectorEnReporte} - Asiento ${numeroEnReporte}`);
                                    return;
                                  }
                                }

                                // Método 4: Buscar solo "Asiento X" (compatibilidad antigua)
                                const matchAsiento = sectorNumeroStr.match(/Asiento\s+(\d+)/i);
                                if (matchAsiento) {
                                  const numeroEnReporte = matchAsiento[1];
                                  if (numeroEnReporte === asiento.numero) {
                                    // Verificar que también coincida el sector
                                    if (sectorNumeroStr.toLowerCase().includes(sector.nombre.toLowerCase())) {
                                      asientosVendidos.add(asiento.id);
                                      console.log(`✅ Asiento vendido (patrón antiguo): ${sector.nombre} - Asiento ${asiento.numero}`);
                                      return;
                                    }
                                  }
                                }
                              });
                            }
                          });
                        }
                      });

                      console.log(`Sector: ${sector.nombre}, Asientos vendidos:`, asientosVendidos.size);

                      // Agrupar asientos por fila y ordenar
                      const asientosPorFila = {};
                      asientosSector.forEach(asiento => {
                        const filaKey = asiento.numeroFila || asiento.fila || 'Sin fila';
                        if (!asientosPorFila[filaKey]) {
                          asientosPorFila[filaKey] = [];
                        }
                        asientosPorFila[filaKey].push(asiento);
                      });

                      // Ordenar las filas de menor a mayor
                      const filasOrdenadas = Object.keys(asientosPorFila).sort((a, b) => {
                        const numA = parseInt(a);
                        const numB = parseInt(b);
                        if (!isNaN(numA) && !isNaN(numB)) {
                          return numA - numB;
                        }
                        return String(a).localeCompare(String(b));
                      });

                      // Ordenar asientos dentro de cada fila de menor a mayor
                      filasOrdenadas.forEach(fila => {
                        asientosPorFila[fila].sort((a, b) => {
                          const numA = parseInt(a.numero);
                          const numB = parseInt(b.numero);
                          return numA - numB;
                        });
                      });

                      return (
                        <div key={sector.id} className="mb-4 border rounded p-3 shadow-sm">
                          <div
                            className="d-flex align-items-center mb-3 pb-2 border-bottom"
                            style={{ borderColor: sector.color + '40' }}
                          >
                            <div
                              className="rounded-circle me-2"
                              style={{
                                width: '20px',
                                height: '20px',
                                backgroundColor: sector.color
                              }}
                            ></div>
                            <h6 className="mb-0 fw-bold">{sector.nombre}</h6>
                            <span className="ms-auto badge bg-secondary">
                              {asientosSector.length} asientos
                            </span>
                          </div>

                          <div
                            className="overflow-auto"
                            style={{
                              maxHeight: '200px',
                              overflowY: 'auto'
                            }}
                          >
                            {/* Renderizar asientos agrupados por fila */}
                            {filasOrdenadas.map((filaKey) => (
                              <div key={filaKey} className="mb-3"
                                style={{
                                  width: '1000px',
                                }}>
                                {/* Etiqueta de fila */}
                                <div className="d-flex align-items-center mb-2">
                                  <div
                                    className="badge"
                                    style={{
                                      backgroundColor: sector.color,
                                      fontSize: '0.75rem',
                                      padding: '3px 8px'
                                    }}
                                  >
                                    Fila {filaKey}
                                  </div>
                                  <div className="ms-2 text-muted small">
                                    {asientosPorFila[filaKey].length} asientos
                                  </div>
                                </div>

                                {/* Asientos de la fila */}
                                <div
                                  className="d-flex flex-wrap gap-2"
                                  style={{ paddingLeft: '8px' }}
                                >
                                  {asientosPorFila[filaKey].map(asiento => {
                                    const estaSeleccionado = asientosSeleccionados.some(a => a.id === asiento.id);
                                    const estaVendido = asientosVendidos.has(asiento.id);

                                    return (
                                      <button
                                        key={asiento.id}
                                        type="button"
                                        className={`btn btn-sm ${estaVendido
                                          ? 'btn-secondary disabled'
                                          : estaSeleccionado
                                            ? 'btn-success'
                                            : 'btn-outline-asiento'
                                          }`}
                                        style={{
                                          width: '55px',
                                          minWidth: '55px',
                                          height: '50px',
                                          fontSize: '0.85rem',
                                          fontWeight: '600',
                                          transition: 'all 0.2s',
                                          backgroundColor: estaSeleccionado ? sector.color : undefined,
                                          borderColor: estaSeleccionado ? sector.color : (estaVendido ? '#6c757d' : sector.color),
                                          color: estaSeleccionado ? '#fff' : (estaVendido ? '#fff' : sector.color),
                                          opacity: estaVendido ? 0.5 : 1,
                                          cursor: estaVendido ? 'not-allowed' : 'pointer',
                                          padding: '3px',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center'
                                        }}
                                        onClick={() => !estaVendido && handleAsientoSelect(asiento)}
                                        disabled={estaVendido}
                                        title={estaVendido ? 'Asiento vendido' : asiento.nombre}
                                      >
                                        <div style={{ fontSize: '0.7rem', lineHeight: '1.2', textAlign: 'center' }}>

                                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-armchair-icon lucide-armchair"><path d="M19 9V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3" /><path d="M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z" /><path d="M5 18v2" /><path d="M19 18v2" /></svg>

                                          {asiento.numeroFila && (
                                            <div style={{ fontSize: '0.5rem', opacity: 0.8 }}>
                                              Fila {asiento.numeroFila}
                                              <span style={{ fontSize: '0.7rem', fontWeight: 'bold' }}>
                                                #{asiento.numero}
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      </button>
                                    );
                                  })}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      );
                    })}

                    {/* Leyenda */}
                    <div className="d-flex gap-2 flex-wrap mt-3 p-2 bg-light rounded">
                      <div className="d-flex align-items-center">
                        <div className="btn btn-outline-primary btn-sm me-1" style={{ width: '25px', height: '20px' }}></div>
                        <small>Disponible</small>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="btn btn-success btn-sm me-1" style={{ width: '25px', height: '20px' }}></div>
                        <small>Seleccionado</small>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="btn btn-secondary btn-sm me-1 disabled" style={{ width: '25px', height: '20px', opacity: 0.5 }}></div>
                        <small>Vendido</small>
                      </div>
                    </div>

                    {asientosSeleccionados.length > 0 && (
                      <div className="mt-3 p-3 bg-success bg-opacity-10 border border-success rounded">
                        <div className="d-flex align-items-center mb-2">
                          <i className="bi bi-check-circle-fill text-success me-2"></i>
                          <strong className="text-success">
                            {asientosSeleccionados.length} asiento{asientosSeleccionados.length > 1 ? 's' : ''} seleccionado{asientosSeleccionados.length > 1 ? 's' : ''}
                          </strong>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                          {asientosSeleccionados.map(asiento => {
                            const sector = siteMap.sectores.find(s => s.id === asiento.sector_id);
                            return (
                              <span
                                key={asiento.id}
                                className="badge"
                                style={{
                                  backgroundColor: sector?.color || '#198754',
                                  fontSize: '0.85rem',
                                  padding: '0.4rem 0.6rem'
                                }}
                              >
                                {sector?.nombre} - #{asiento.numero}
                              </span>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  // Mapa real con Konva para sitemaps físicos
                  <div>
                    <h6 className="text-success">MAPA DE ASIENTOS</h6>
                    <SiteMapViewer
                      fechaSeleccionada={`${form.fecha} HORA: ${form.hora}`}
                      siteMap={siteMap}
                      onAsientoSelect={handleAsientoSelect}
                      asientosSeleccionados={asientosSeleccionados.map(a => a.id)}
                      entradas={entradas}
                      reportes={evento.reportes}
                    />
                    {asientosSeleccionados.length > 0 && (
                      <div className="mt-2 p-2 bg-light rounded">
                        <small className="fw-bold">Asientos seleccionados:</small>
                        <div className="d-flex flex-wrap gap-1 mt-1">
                          {asientosSeleccionados.map(asiento => (
                            <span key={asiento.id} className="badge bg-success">
                              Fila {asiento.fila} - Asiento {asiento.numero}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : (
              /* Si NO hay selector de asientos pero existe maps_sitio, mostrarlo */
              evento.maps_sitio ? (
                <div className="mb-3 border rounded overflow-hidden shadow-sm">
                  <div className="bg-naranja text-white p-2 d-flex justify-content-between align-items-center">
                    <small className="fw-bold">
                      <i className="bi bi-map me-1"></i>
                      Mapa de Referencia
                    </small>
                    <small className="text-white-50">
                      <i className="bi bi-zoom-in me-1"></i>
                      Toca para ampliar
                    </small>
                  </div>
                  <img
                    src={evento.maps_sitio}
                    alt="Mapa de guía de asientos"
                    className="w-100"
                    style={{
                      maxHeight: '300px',
                      objectFit: 'contain',
                      backgroundColor: '#f8f9fa',
                      cursor: 'pointer'
                    }}
                    onClick={() => {
                      // Crear modal de zoom
                      const modal = document.createElement('div');
                      modal.style.cssText = `
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background: rgba(0,0,0,0.9);
                        z-index: 9999;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding: 20px;
                        cursor: zoom-out;
                      `;

                      const img = document.createElement('img');
                      img.src = evento.maps_sitio;
                      img.style.cssText = `
                        max-width: 100%;
                        max-height: 100%;
                        object-fit: contain;
                        box-shadow: 0 0 30px rgba(255,255,255,0.2);
                      `;

                      const closeBtn = document.createElement('button');
                      closeBtn.innerHTML = '<i class="bi bi-x-lg"></i>';
                      closeBtn.style.cssText = `
                        position: absolute;
                        top: 20px;
                        right: 20px;
                        background: white;
                        border: none;
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                        font-size: 20px;
                        cursor: pointer;
                        box-shadow: 0 2px 10px rgba(0,0,0,0.3);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      `;

                      modal.appendChild(img);
                      modal.appendChild(closeBtn);
                      document.body.appendChild(modal);

                      const cerrarModal = () => {
                        modal.remove();
                      };

                      modal.addEventListener('click', cerrarModal);
                      closeBtn.addEventListener('click', cerrarModal);

                      // Evitar que el click en la imagen cierre el modal
                      img.addEventListener('click', (e) => e.stopPropagation());
                    }}
                  />
                </div>
              ) : null
            )}
          </div>
          <div className="col-md-5 d-none">
            <div className="border h-100 overflow-hidden">
              <img
                src={image}
                className="w-100 h-100"
                style={{ objectFit: "cover" }}
                alt=""
              />
            </div>
          </div>
          <div className="col-md-7">
            <div>
              <nav>
                <div
                  className="nav nav-tabs d-flex justify-content-center align-items-center border-0 py-3"
                  id="nav-tab-ofcanva"
                  role="tablist"
                >
                  <button
                    className={
                      step == 0
                        ? "bg-transparent fw-bold text-custom-naranja border-0 d-flex items-align-center "
                        : "bg-transparent fw-bold text-dark border-0 d-flex items-align-center "
                    }
                    onClick={() => setStep(0)}
                    id="nav-cantidad-tab-ofcanva"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-cantidad-ofcanva"
                    type="button"
                    role="tab"
                    aria-controls="nav-cantidad-ofcanva"
                    aria-selected="false"
                  >
                    <i
                      className={
                        step == 0
                          ? "bi bi-2-circle-fill text-custom-naranja fw-bold titulo-size me-2"
                          : "bi bi-2-circle-fill text-dark fw-bold titulo-size me-2"
                      }
                    ></i>
                    <span className="titulo-size Grifter">Elegir entrada</span>
                  </button>
                  <div
                    className="d-none d-md-block"
                    style={{
                      borderBottom: "1px solid black",
                      width: "60px",
                      height: "1px",
                    }}
                  ></div>
                  <button
                    className={
                      step == 1
                        ? "bg-transparent fw-bold text-custom-naranja border-0 d-flex items-align-center me-3"
                        : "bg-transparent fw-bold text-dark border-0 d-flex items-align-center me-3"
                    }
                    onClick={() => setStep(1)}
                    id="nav-pagar-tab-ofcanva"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-pagar-ofcanva"
                    type="button"
                    role="tab"
                    aria-controls="nav-pagar-ofcanva"
                    aria-selected="false"
                  >
                    <i
                      className={
                        step == 1
                          ? "bi bi-3-circle-fill text-custom-naranja fw-bold titulo-size me-2"
                          : "bi bi-3-circle-fill text-dark fw-bold titulo-size me-2"
                      }
                    ></i>
                    <span className="titulo-size Grifter">Pagar</span>
                  </button>
                </div>
              </nav>
              <div className="tab-content" id="nav-tabContent-ofcanva">
                <div
                  className="tab-pane fade py-5 show active"
                  id="nav-cantidad-ofcanva"
                  role="tabpanel"
                  aria-labelledby="nav-cantidad-tab-ofcanva"
                  tabindex="0"
                >
                  {entradas.map((entrada, index) => {
                    // Verificar sector en diferentes formatos
                    const tieneSector = (typeof entrada.sector === 'string' && entrada.sector.trim() !== "") ||
                      (entrada.sector && entrada.sector[0] && entrada.sector[0].trim() !== "");

                    const nombreSector = typeof entrada.sector === 'string' ? entrada.sector : (entrada.sector && entrada.sector[0] ? entrada.sector[0] : "");

                    // NUEVO: Verificar si hay match por nombre con algún sector del mapa
                    let tieneMatchEnMapa = false;
                    if (siteMap && siteMap.sectores && !tieneSector) {
                      tieneMatchEnMapa = siteMap.sectores.some(sector => {
                        const nombreSectorMapa = sector.nombre || sector.name || '';
                        const nombreEntrada = entrada.nombre || '';
                        return nombreSectorMapa.trim().toLowerCase() === nombreEntrada.trim().toLowerCase();
                      });
                    }

                    // Lógica de ocultamiento mejorada:
                    // Si hay sitemap con asientos, SOLO mostrar entradas que:
                    // 1. Tienen sector explícito (tieneSector = true), O
                    // 2. Tienen match por nombre con un sector del mapa (tieneMatchEnMapa = true)
                    const debeOcultarse = entradaConSector && !tieneSector && !tieneMatchEnMapa;

                    return (
                      <div
                        key={index}
                        className={`${ValidarEntrada(entrada) ? "" : "d-none"} ${debeOcultarse ? "d-none" : ""}`}
                      >
                        <div
                          className="text-center  d-md-flex d-block justify-content-between"
                          style={{
                            opacity: entrada.quantity ? 1 : 0.5,
                          }}
                        >
                          <div className="fw-bold fs-6 text-start text-dark d-block">
                            <div>{entrada.nombre}
                              {
                                entrada.multiplicador
                                  ? ` x${entrada.multiplicador}`
                                  : ''
                              }
                            </div>
                            {tieneSector && (
                              <small className="text-muted d-block">
                                Sector: {nombreSector}
                              </small>
                            )}
                            {!tieneSector && tieneMatchEnMapa && (
                              <small className="text-success d-block">
                                <i className="bi bi-diagram-3"></i> Selección por mapa
                              </small>
                            )}
                          </div>
                          <span className="fw-bold fs-5 text-dark">
                            $
                            {entrada.pricexquantity
                              ? parseFloat(
                                entrada.pricexquantity
                              ).toLocaleString("es-AR", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                              : parseFloat(entrada.precio).toLocaleString(
                                "es-AR",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )}
                          </span>
                          <div>
                            {(tieneSector || tieneMatchEnMapa) ? (
                              <div className="text-center">
                                <div className="bg-naranja px-2 text-white tw-rounded-md mb-2">
                                  {entrada.quantity ?? 0} asiento{(entrada.quantity ?? 0) !== 1 ? 's' : ''} seleccionado{(entrada.quantity ?? 0) !== 1 ? 's' : ''}
                                </div>
                                <small className="d-block text-muted">
                                  Selecciona en el mapa
                                </small>
                              </div>
                            ) : (
                              <div className=" d-flex justify-content-center">
                                <button
                                  className="btn py-2 px-4 fw-bold fs-6 border border-dark"
                                  style={{
                                    borderRadius: "20px 0px 0px 20px",
                                  }}
                                  name="remove"
                                  onClick={(event) =>
                                    onClick(event, {
                                      ...entrada,
                                      index: index,
                                    })
                                  }
                                >
                                  -
                                </button>
                                <input
                                  className="form-controll py-1 text-center fs-6 GothamBold"
                                  type="number"
                                  value={entrada.quantity ?? 0}
                                  style={{ width: "100px" }}
                                  readOnly
                                />
                                <button
                                  className="border-dark btn py-1 px-4 fw-bold fs-6 border"
                                  style={{
                                    borderRadius: "0px 20px 20px 0px",
                                  }}
                                  name="add"
                                  onClick={(event) => {
                                    if (entrada.remain !== 0) {
                                      onClick(event, {
                                        ...entrada,
                                        index: index,
                                      });
                                    }
                                  }}
                                >
                                  +
                                </button>
                              </div>
                            )}

                            <span
                              className={`${ValidarStock(entrada, form, evento.reportes)
                                ? "d-none"
                                : ""
                                }`}
                              style={{ fontSize: "10px" }}
                            >
                              <span className={`ms-1`}>Entradas agotadas</span>
                            </span>

                            <span
                              className={`${ValidarStock(entrada, form, evento.reportes)
                                ? ""
                                : "d-none"
                                }`}
                              style={{ fontSize: "10px" }}
                            >
                              {"+Serv ARS " +
                                parseFloat(entrada.serv ?? 0).toLocaleString(
                                  "es-AR",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                ) ?? 0}
                              <span
                                className={`ms-1  ${entrada.remain <= 20 ? "" : "d-none"
                                  }`}
                              >
                                Quedan {entrada.remain ?? 0} entradas!
                              </span>
                            </span>
                          </div>
                        </div>

                        <hr></hr>
                      </div>
                    );
                  })}

                  <div className="row">
                    <div className="col-md-6 mb-2">
                      <span className="d-block fw-bold">{evento?.nombre}</span>
                      <span className="d-block">{evento?.nombre_sitio}</span>
                      <span className="d-block">{`${form.fecha} Hora: ${form.hora}`}</span>
                    </div>
                    <div className="col-md-6">
                      <div className="w-100 d-flex justify-content-between">
                        <div className="fs-6 fw-bold">SubTotal</div>
                        <div className="fs-6 fw-bold">
                          {"ARS " +
                            parseFloat(
                              TotalEntradaUtils(evento.entradas, comission)
                                .subTotal
                            ).toLocaleString("es-AR", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                        </div>
                      </div>
                      <div className="w-100 d-flex justify-content-between">
                        <div className="fs-6 fw-bold">+Serv ({comission}%)</div>
                        <div className="fs-6 fw-bold">
                          {"ARS " +
                            parseFloat(
                              TotalEntradaUtils(evento.entradas, comission).serv
                            ).toLocaleString("es-AR", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                        </div>
                      </div>
                      <div className="w-100 d-flex justify-content-between">
                        <div className="fs-6 fw-bold">Total</div>
                        <div className="fs-6 fw-bold">
                          {"ARS " +
                            parseFloat(
                              TotalEntradaUtils(evento.entradas, comission)
                                .total
                            ).toLocaleString("es-AR", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="tab-pane fade"
                  id="nav-pagar-ofcanva"
                  role="tabpanel"
                  aria-labelledby="nav-pagar-tab-ofcanva"
                  tabindex="1"
                >
                  <ul class="list-group">
                    <li class="px-3 py-3 rounded-0 list-group-item p-0 m-0 mb-1 border-start-0 border-end-0">
                      <span className="d-block fw-bold">{evento?.nombre}</span>
                      <span className="d-block">{evento?.nombre_sitio}</span>
                      <span className="d-block">{`${form.fecha} Hora: ${form.hora}`}</span>
                    </li>

                    <li class="px-3 py-3 rounded-0 list-group-item p-0 m-0 border-start-0 border-end-0 ">
                      <span className="GothamBold d-block">Entradas</span>
                      {evento?.entradas.map((entrada, index) => {
                        if (entrada.quantity > 0) {
                          return (
                            <div
                              className="d-flex justify-content-between"
                              key={index}
                            >
                              <span className="GothamBold fs-6">
                                {`${entrada.nombre} x${entrada.quantity}`}
                              </span>
                              <span className="GothamBold fs-6">{`ARS ${parseFloat(
                                entrada.pricexquantity
                              ).toLocaleString("es-AR", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}`}</span>
                            </div>
                          );
                        }
                      })}
                    </li>

                    <li class="px-3 py-3 rounded-0 list-group-item p-0 m-0 border-start-0 border-end-0 ">
                      <div className="d-flex justify-content-between">
                        <span className="GothamBold fs-6">SubTotal</span>
                        <span className="GothamBold fs-6">
                          {" "}
                          {"ARS " +
                            parseFloat(
                              TotalEntradaUtils(evento.entradas, comission)
                                .subTotal
                            ).toLocaleString("es-AR", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                        </span>
                      </div>
                    </li>

                    <li class="px-3 py-3 rounded-0 list-group-item p-0 m-0 border-start-0 border-end-0 ">
                      <div className="d-flex justify-content-between">
                        <span className="GothamBold fs-6">
                          +Serv({comission}%)
                        </span>
                        <span className="GothamBold fs-6">
                          {" "}
                          {"ARS " +
                            parseFloat(
                              TotalEntradaUtils(evento.entradas, comission).serv
                            ).toLocaleString("es-AR", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                        </span>
                      </div>
                    </li>

                    <li class="px-3 py-3 rounded-0 list-group-item p-0 m-0 border-0 ">
                      <div className="d-flex justify-content-between">
                        <span className="GothamBold fs-5">Total</span>
                        <span className="GothamBold fs-5">
                          {"ARS " +
                            parseFloat(
                              TotalEntradaUtils(evento.entradas, comission)
                                .total
                            ).toLocaleString("es-AR", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="d-block d-md-flex justify-content-center">
              <label
                className={
                  step == 0
                    ? "d-none"
                    : "btn btn-outline-dark fw-normal py-4 fs-6 d-flex justify-content-center align-items-center  me-2 mb-2 w-100 w-md-auto"
                }
                style={{
                  width: "160px",
                  lineHeight: 1,
                  padding: "10px 20px 10px",
                  borderRadius: "10px",
                }}
              >
                <i class="bi bi-chevron-left fs-6"></i>
                Atras
                <button
                  className="d-none"
                  onClick={(e) => {
                    let int = step - 1;
                    switch (int) {
                      case 0:
                        {
                          document.getElementById("nav-cantidad-tab").click();
                          document
                            .getElementById("nav-cantidad-tab-ofcanva")
                            .click();
                        }
                        break;
                      default:
                        break;
                    }
                    setStep(int);
                  }}
                ></button>
              </label>

              {label(step)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfComprarEntradas;
